module.exports = __webpack_public_path__ + "static/media/decor3.c0af6095.jpg";